import { render, staticRenderFns } from "./MagazineForm.vue?vue&type=template&id=7695a4c8&scoped=true"
import script from "./MagazineForm.vue?vue&type=script&lang=js"
export * from "./MagazineForm.vue?vue&type=script&lang=js"
import style0 from "./MagazineForm.vue?vue&type=style&index=0&id=7695a4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695a4c8",
  null
  
)

export default component.exports